import React from 'react';
import {useSelector} from 'react-redux';
import {Col, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {HPV_TEST_KEYS} from '~/constants/medical-questionnaires';
import {RootState} from '~/redux/root-reducer';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire3Screen = () => {
  const {questionnaires} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(i => i.key === HPV_TEST_KEYS.INVALID);

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions}>
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.ultra} mt={spacing.large} />
        <UiText fontSize="2xl" fontWeight="bold" mt={spacing.xmedium}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText color="blackSecondary" fontSize="sm" mt={spacing.xmedium} px={spacing.medium}>
          {questionnaire?.descriptions?.default}
        </UiText>
        <UiText color="blackSecondary" fontSize="sm" mt={spacing.small} px={spacing.medium}>
          {questionnaire?.descriptions?.sub}
        </UiText>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire3Screen;
